<template>
  <div class="menu">
    <div class="menu-items">
      <div class="menu-item"  :class="this.menuSelected.dashboard && 'active'">
        <a href="/home" class="dashboard ">{{
          $t("cmsLang.dashboardName")
        }}</a>
      </div>
      <div class="menu-item" :class="menuSelected.manageGames && 'active'">
        <a href="/manage_games" class="games menu-item" >{{
          $t("cmsLang.manageGamesName")
        }}</a>
      </div>
      <div class="menu-item" :class="menuSelected.manageRewards && 'active'">
        <a href="/manage_rewards" class="rewards menu-item" >{{
          $t("cmsLang.manageRewardsName")
        }}</a>
      </div>
      <div class="menu-item"  :class="menuSelected.campaign && 'active'">
        <a href="/sms_push" class="campaigns menu-item">{{
          $t("cmsLang.campaignName")
        }}</a>
      </div>
      <!-- only if user is admin we show user management -->
      <div class="menu-item" v-if="this.isUserAdmin(user)"  :class="menuSelected.manageUsers && 'active'">
        <a href="/manage_users" class="users menu-item">{{
          $t("cmsLang.manageUsersName")
        }}</a>
      </div>
      
      <div class="menu-item" :class="menuSelected.profile && 'active'">
        <a href="/profile" class="settings menu-item" >{{
          $t("cmsLang.profileName") }}</a>
      </div>
      <div class="menu-item">
        <a href="#" class="logout menu-item" @click="logout()">{{ $t("cmsLang.logoutName") }}</a>
      </div>

    </div>
  </div>
</template>
<script>
  import Cookies from "js-cookie";
  export default {
    name: "MenuItems",
    props: {
      user: Object,
      menuSelected: Object,
    },
    methods: {
      logout() {
        Cookies.remove("user_role");
        Cookies.remove("token");
        this.$router.push({
          name: "login",
        });
      },
    },
  };
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
